__turbopack_context__.v({
  "SendPost": "send-post-module__Vo-0cW__SendPost",
});
